import { render, staticRenderFns } from "./DependencyPickerItem.vue?vue&type=template&id=3d54f34b&scoped=true&"
import script from "./DependencyPickerItem.vue?vue&type=script&lang=js&"
export * from "./DependencyPickerItem.vue?vue&type=script&lang=js&"
import style0 from "./DependencyPickerItem.vue?vue&type=style&index=0&id=3d54f34b&lang=scss&scoped=true&"
import style1 from "./DependencyPickerItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54f34b",
  null
  
)

export default component.exports